<template>
  <div class="navsBox rPos">
      <div v-view 
        opressmove:stop:nosel='return t=$Menus.actived, EE.move ? t.collapse=(t.width=Math.max(EE.Dtemp+EE.moveX,50))<=50 : parseInt(t.width);'
        o:pressmove:stop:nosel='return t = $Menus.actived, [ EE.move && ( t.collapse = ( t.width = Math.max( EE.moveAbsX, 50 ) ) <= 50 ), parseInt(t.width) ]'
        o:dblclick:stop='$Menus.toggleCollapse()'
        title="拖拽移动, 双击还原"
        style="position: absolute;width: 14px;height: 100%;right: -7px;cursor: col-resize;"></div>
      <el-aside :width="Menus.actived.width>-1?Menus.actived.width+'px':Menus.actived.width" style="overflow: hidden;" id='Menuaside'>
        <el-menu 
          ref='menu'
          style='overflow: auto;height: 100vh;padding-bottom: 50px;box-sizing: border-box;'
          :default-openeds="opened.length > 0 ? opened : actived.opened"
          :unique-opened="onlyOpen"  
          :default-active="actived.index||''"
          :collapse='actived.collapse'
          class="el-menu-vertical-demo"
          active-text-color="#ffd04b" :menu.prop='(Menus,indexMenu={__proto__:null})'>
          <div v-for='(menu,index) in Menus' :key='index+":"'>

            <el-submenu v-if='menu.submenus && ( menu.show || menu.show === void 0 )' :index="( indexMenu[menu.index=index+1+''] = menu ).index" class="borerLine" :title='actived.collapse ? menu.name || "?" : ""'>
              <template slot="title">
                <span v-once :opened='menu.defaultOpened && ( actived.opened.push(menu.index), menu.defaultOpened = false ) ' ></span>
                <i :class="'menu-icon fa fa-tachometer black ' + (menu.icon||'') "></i>
                <span id='Menutitle' >{{ menu.name || '?' }}</span>
              </template>

              <div v-for='(menu,index2) in menu.submenus' :key='index2+":"'>
                
                <el-submenu v-if='menu.submenus && ( menu.show || menu.show === void 0 )' :index="( indexMenu[menu.index=index2+1+''] ).index" class="borerLine" :opened='menu.defaultOpened && opened.put(menu.index) && delete menu.defaultOpened'>
                  <template slot="title">
                    <span v-once :opened='menu.defaultOpened && ( actived.opened.push(menu.index), menu.defaultOpened = false ) ' ></span>
                    <i :class="'menu-icon fa fa-tachometer black ' + (menu.icon||'') "></i>
                    <span id='Menutitle' >{{ menu.name || '?' }}</span>
                  </template>

                  <div v-for='(menu,index3) in menu.submenus' :key="menu.index=(index+1)+'-'+(index2+1)+'-'+(index3+1)">
                   
                    <el-menu-item v-if='( menu.show || menu.show === void 0 )' @click='$push(menu)'  :index="( indexMenu[menu.index] = menu ).index"  >
                        <i :class="'menu-icon fa fa-tachometer black ' + (menu.icon||'') "></i>
                        <a onclick='return event.preventDefault(),event.returnValue=false;' :href="'#/'+Menus.getPath(menu)">{{ menu.name || '?' }}</a>
                    </el-menu-item>

                  </div>

                </el-submenu>


                <el-menu-item @click='$push(menu)' v-else-if='( menu.show || menu.show === void 0 )' :index="( indexMenu[menu.index=(index+1)+'-'+(index2+1)] = menu ).index">

                    <i :class="'menu-icon fa fa-tachometer black ' + (menu.icon||'') "></i>
                    <a onclick='return event.preventDefault(),event.returnValue=false;' :href="'#/'+Menus.getPath(menu)">{{ menu.name || '?' }}</a>

                </el-menu-item>

              </div>

          </el-submenu>

          <el-menu-item @click='$push(menu)' v-else-if='( menu.show || menu.show === void 0 )' :index="( indexMenu[menu.index=index+1+''] = menu ).index" :title='actived.collapse ? menu.name || "?" : ""'>
              <i :class="'menu-icon fa fa-tachometer black ' + (menu.icon||'') "></i>
              <a onclick='return event.preventDefault(),event.returnValue=false;' id='Menutitle' :href="'#/'+Menus.getPath(menu)">{{ menu.name || '?' }}</a>
          </el-menu-item>

        </div>
      </el-menu>

      <span v-once :initMenuEnd='initMenuEnd=true'></span>
    </el-aside>
  </div>
</template>
<script>
import myhttp from "../utils/myhttp.js";
import qs from "qs";
let W = window, $Menus, $Englishmenus;
// console.error(222222);
export default {
  name: 'navs',
  data() {
    const item = {};
    // this.indexMenu = { __proto__: null };
    return {
      ROLE_ID: localStorage.getItem("ROLE_ID"),
      theMenu: [],

      opened: [ ],
      onlyOpen: true,
      Menus: $Menus||( $Menus = W.$Menus ),
      actived: $Menus.actived||0,
      
    };
  },
  watch: {
    
  },
  methods: {
    getQuanXian: async function(ROLE_ID) {
      var postData = {
        roleId: ROLE_ID
      };
      var s = qs.stringify(postData);
      const responseData = await myhttp.post("/roleLwm/menuqx", s);
      this.theMenu = responseData.data.items;
      if (responseData.data.result == "success") {
      } else {
        this.$message({
          message: responseData.data.msg,
          type: "error"
        });
      }
    }
  },
  created() {
    // console.error(this);
    (( $Menus || ( $Menus = W.$Menus ) ).actived.created||A.returnValue())(this);
    const Actived = $Menus.actived;
    const index = Actived.initIndex;
    // console.warn( index, Actived );
    if( index ) {
      const isnumber = index[0] > -1 && index.includes('-') ? true : ( Actived.index = '', false );
      // console.error( index, isnumber, 4444444444 )
      this.myBind('initMenuEnd',menu=>{
        menu = ( isnumber ? this.indexMenu[ index ] : $Menus.Englishmenus[ index ] || $Menus.Chinamenus[ index ] );
        Actived.index = menu.index;
        // console.error( A.local(A.loginTypeword) && this.$route.meta );
        if( A.local(A.loginTypeword) ) {
          const ismenu = this.$route.meta.ismenu;
          ( !ismenu || ismenu.parent.type !== '老师' ) && this.$push( menu );
        };
        // console.error(this.indexMenu,9999999999, Actived.index, menu, this.$route.path );
        // sleep(5000).then(v=>this.$push(menu));
      });
      Actived.initIndex = null;
    };
    // console.error(index,77777777);
    this.$watch('actived.collapse',async (bool,width)=>{
      var el = this.$refs.menu.$el;
      if( !el.classList ) return;
      el.classList.toggle('el-menu--collapse');
      el.style.setProperty( 'width', ( width = bool ? Actived.collapseWidth : Actived.defaultWidth ) + 'px', 'important' );
      ( el = el.parentElement.style ).transition = 'width 180ms ease-in-out';
      // console.error(el);
      await sleep(25);
      Actived.width = width;
      await sleep(200);
      // console.error(el);
      el.transition = '';
    });
    Actived.navs = this;
    const $push = this.$push;
    this.$push = menu=>{
      $push.call(this,menu.path||menu.url);
    };
  }
};
</script>
<style scoped>
.navsBox {
  /*width: 200px;*/
  height: 100%;
  border-right: 1px solid #dfdedf;
  box-shadow: 4px 0px 2px #f3f3f3;
}
.borerLine {
  border-bottom: 1px solid #f2f2f2;
}
.el-submenu__title {
  font-size: 16px;
}
.menuItem a {
  color: #999999;
}
.el-menu-item.is-active a {
  /*color: #e94e02;*/
  /*color: var(--Themecolor);*/
  text-decoration: none;
  /*text-shadow: 0px 0px 1px;*/
}
.el-header {
  font-size: 12px;
  background-color: #b3c0d1;
  color: #767575;
  line-height: 60px;
}
.borerLine .iconfont {
  margin-right: 5px;
  font-size: 19px;
}
.el-aside {
  color: #333;
}
.el-submenu .el-menu-item {
  height: 40px;
  line-height: 40px;
  padding: 0 45px;
  min-width: 189px;
  border: 1px dotted;
  border-width: 1px 0 0;
  border-color: #bbb;
}
.menu-icon {
  display: inline-block;
  /*min-width: 30px;*/
  /*margin-right: 2px;*/
  vertical-align: sub;
  /*text-align: center;*/
  font-size: 14px;
  font-weight: normal;
}
.el-menu-item-group__title {
  padding: 0;
}
.blue {
  color: #2569a1;
}
.green {
  color: #69aa46;
}
.black {
  color: #585858;
}
</style>




// WEBPACK FOOTER //
// src/components/$navs.local.vue